const createExchangeReport = ({ exchangeStatusAtom, }) => ({
    namespace: 'exchange',
    export: async () => {
        const data = await exchangeStatusAtom.get();
        if (!data) {
            return null;
        }
        return {
            ...data,
            fromAmount: data.fromAmount.toDefaultString({ unit: true }),
            toAmount: data.toAmount.toDefaultString({ unit: true }),
        };
    },
});
const exchangeReportDefinition = {
    id: 'exchangeReport',
    type: 'report',
    factory: createExchangeReport,
    dependencies: ['exchangeStatusAtom'],
    public: true,
};
export default exchangeReportDefinition;
